import { useEffect, useRef, useState } from "react";
import "./landing.css";

// Blendet seinen Inhalt ein, sobald er im Viewport steht, und setzt dabei die
// Klasse `lp-in` — daran hängen die CSS-Animationen der Landingpage.
export default function Reveal({ children, y = 16, delay = 0, once = true, flexItemStyle, className = "" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), delay);
          if (once) obs.unobserve(el);
        } else if (!once) {
          setVisible(false);
        }
      },
      { threshold: 0.15 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [delay, once]);

  const style = {
    ...flexItemStyle, // wichtig für Flex-Layout!
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : `translateY(${y}px)`,
    willChange: "opacity, transform",
  };

  return (
    <div
      ref={ref}
      className={`lp-reveal${visible ? " lp-in" : ""}${className ? ` ${className}` : ""}`}
      style={style}
    >
      {children}
    </div>
  );
}
